import {
	VIEWKYCDETAILS_SUCCESS,
	VIEWKYCDETAILS_FAILED,
	RESET_VIEWKYCDETAILS,
	LOADING_VIEWKYCDETAILS,
	NETWORK_ERROR_VIEWKYCDETAILS
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_VIEWKYCDETAILS:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case VIEWKYCDETAILS_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case VIEWKYCDETAILS_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_VIEWKYCDETAILS:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_VIEWKYCDETAILS:
			return (state = initialState);
		default:
			return state;
	}
};
